import CustomDataTable from '../../components/CustomDataTable/CustomDataTable';
import { ENDPOINT } from '../../services/endPoints';
import InformationBox from '../../components/InformativeBox/InformativeBox';
import React from 'react'
import { conditionalRowStyles } from './PatientReferredList';

const AllTest = () => {
  const excludedKeys = ['id', 'form_viewed',  'year', 'doctore_comments1', 'doctore_comments2', 'form_filling_Date', 'doctore_comments3', "createdAt", "updatedAt", "deletedAt",
"patient_DOB","form_code","hospital_region" ,"patient_code","patient_cmis_id","facility_type","nurses_region","pf_id",
"nurses_id","hospital_id","form_accept_reject","patient_gender"];

  const compareValue = [
"id",
"patient_name",
"patient_age",
"patient_DOB",
"patient_gender",
"patient_natinal_id",
"patient_cmis_id",
"patient_code",
"nurses_id",
"facility_name",
"facility_type",
"hospital_id",
"hospital_Name",
"hospital_region",
"doctore_comments1",
"doctore_comments2",
"doctore_comments3",
"form_viewed",
"form_filling_Date",
"form_code",
"form_type",
"form_risk_rating",
"createdAt",
"updatedAt",
"deletedAt",
"pf_id",
"nurse_name",
"hospital_id",
];

  const customKeyName = {
    "patient_name": "Name",
    "patient_age": "Age",
    "patient_gender": "Sex",
    "patient_natinal_id": "National ID",
    "nurse_name": "Nurse Name",
    "facility_name": "Facility Name",
    "hospital_Name": "Referred Facility",
    "form_viewed": "Form Viewed",
    "form_type": "Form Type",
    "form_risk_rating": "Risk Rating",

  }

  const customWidth = {
    patient_name: "150px",
    patient_age: "30px",
    patient_gender: "30px",
    patient_natinal_id: "200px",
    facility_name: "130px",
    hospital_Name: "150px",
    form_viewed: "100px",
    form_type: "100px",
  }


  return (
    <>
    <CustomDataTable 
                tableTitle={"All Test List"}
                endPoint={ENDPOINT.DASHBOARD_ALLTEST}
                filterKey={"patient_name"}
                excludedKeys={excludedKeys}
                customKeyName={customKeyName}
                compareValue={compareValue}
                customWidth={customWidth}
                conditionalRowStyles={conditionalRowStyles}
                />

                <InformationBox/>
    </>
  )
}

export default AllTest